import { createBasicSelector } from 'util/redux'
import { selectBooleanPreferenceByName } from './selectBooleanPreferenceByName'

export const selectCurrentUserPrefersPreviewOnHover = createBasicSelector(
  state =>
    selectBooleanPreferenceByName(state, 'conversation_preview_on_hover', false)
)
